import businessCustomerService from "../../../services/businessCustomer/businessCustomer.service";
import { businessCustomerActionTypes } from "../../actionTypes/businessCustomer/businessCustomer.actionTypes";

export const fetchBusinessCustomers = () => async (dispatch) => {
  try {
    dispatch({ type: businessCustomerActionTypes.START_FETCH_CUSTOMERS });

    const response = await businessCustomerService.getBusinessCustomerList();
    dispatch({
      type: businessCustomerActionTypes.FETCH_CUSTOMERS_SUCCESS,
      data: response.data.payload,
    });
  } catch (error) {
    console.error("Error fetching business customers:", error);
    dispatch({
      type: businessCustomerActionTypes.FETCH_CUSTOMERS_FAILURE,
      error: error.response?.data || "Failed to fetch business customers.",
    });
  }
};

const businessCustomerActions = {
  fetchBusinessCustomers,
};

export default businessCustomerActions;
